import IHwrcSite from "interfaces/IHwrcSite";
import { GlobalState } from "little-state-machine";

export const updateSelectedHwrcSite = (state: GlobalState, selectedHwrcSite: IHwrcSite | undefined) => ({
  ...state,
  selectedHwrcSite
});
